import {EnvGlobalsHandler, MathBase} from "@goodgamestudios/core";
import { BasicSessionData } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicDialogHandler } from "@goodgamestudios/core";
import { Timer } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../constants/SFConstants";
import { BonusVO } from "../../gamevo/BonusVO";
import { Poker2LoginBonusDialog } from "../../view/dialogs/login/Poker2LoginBonusDialog";
import { Poker2LoginBonusDialogProperties } from "../../view/dialogs/login/Poker2LoginBonusDialogProperties";
import { Poker2PaymentTeaserDialog } from "../../view/dialogs/Poker2PaymentTeaserDialog";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";
import { BonusVOParseHelper } from "../helper/BonusVOParseHelper";

import TimerEvent = createjs.TimerEvent;

export class Poker2SessionData extends BasicSessionData {
    private _ignorList: any[];
    public activeSpecialOffer: boolean = false;
    public specialOffer_Cash: number = NaN;
    public specialOffer_Gold: number = NaN;
    public specialOffer_Delay: number = 0;
    public activeSpecialOfferXP: boolean = false;
    public specialOffer_XP: number = 0;
    public specialOffer_XP_timeleft: number = 0;
    public highestSpecialOffer: number = 0;
    public specialOffer_RegisterBonus: boolean = false;
    public inGameCMDArray: any[];
    public SPECIALOFFER_TIMER: string = "specialOffer";
    public OFFER_INTERVAL: number = 1000 * 60 * 60 * 2;

    public BUDDY_ONLINEREQUEST_INTERVAL: number = 1000 * 60;	// alle 5min
    public BUDDY_ONLINEREQUEST_TIMER: string = "BuddyOnlineRequestTimer";

    private startupDate: number;

    constructor() {
        CONSTRUCTOR_HACK;
        super();
        this.inGameCMDArray = new Array();
        this.activeSpecialOffer = false;
        this.activeSpecialOfferXP = false;

        this.startupDate = Date.now();

        this._currentEvents = [];
    }
    public initIgnorList(): void {
        this.ignorList = [];
    }
    /**
     * CommandId and JSON-Object
     */
    public addInGameCommand(cmdId: string, paramObj: any): void {
        var cmdObject: any = { cmdId: cmdId, paramObj: paramObj };
        this.inGameCMDArray.push(cmdObject);
    }
    public executeInGameCommands(): void {
        for (var i: number = 0; i < this.inGameCMDArray.length; i++) {
            var cmdObject: any = this.inGameCMDArray[i];
            switch (cmdObject.cmdId) {
                case "gdb":

                    var bonusVOs: BonusVO[] = BonusVOParseHelper.parseBonusVOs(cmdObject.paramObj);
                    if (bonusVOs) {
                        Poker2LayoutManager.getInstance().showDialog("Poker2LoginBonusDialog", new Poker2LoginBonusDialogProperties(cmdObject.paramObj.day, bonusVOs));
                    }
                    break;
            }
        }
        this.inGameCMDArray = new Array();
    }
    public addToIgnorList(playerId: number): void {
        for (var i: number = 0; i < this.ignorList.length; i++) {
            if (this.ignorList[i] == playerId) {
                this.ignorList.splice(i, 1);
                return;
            }
        }
        this.ignorList.push(playerId);
    }
    public isOnIgnorList(playerId: number): boolean {
        for (var i: number = 0; i < this.ignorList.length; i++) {
            if (this.ignorList[i] == playerId)
                return true;
        }
        return false;
    }

    public get ignorList(): any[] {
        return this._ignorList;
    }

    public set ignorList(value: any[]) {
        this._ignorList = value;
    }

    protected onSessionTimerComplete(event: TimerEvent): void {
        if (this.isSessionTimerById(this.SPECIALOFFER_TIMER, (event.target as Timer))) {
            event.target.reset();
            this.specialOffer_Delay = int(MathBase.max(0, this.specialOffer_Delay - this.OFFER_INTERVAL / 1000));
            if (Poker2LayoutManager.getInstance().inGameState) {
                BasicDialogHandler.getInstance().registerDialogs("PokerPaymentTeaserDialog", null, true, BasicDialogHandler.PRIORITY_MIDDLE);
            }
            event.target.start();
        }
        if (this.isSessionTimerById(this.BUDDY_ONLINEREQUEST_TIMER, (event.target as Timer))) {
            event.target.reset();
            if (Poker2LayoutManager.getInstance().inGameState)
                BasicModel.smartfoxClient.sendMessage("bos", []);
            event.target.start();
        }
    }

    public getTimeSinceGameStart(): number {
        return Date.now() - this.startupDate;
    }

}
